import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useStore from '@/composables/useStore';
import { RecordingReaction } from '@/@types/RecordingReaction';
import { Article } from '@/models/article/Article';
import ArticleTimelineReaction from '@/components/article-player/ArticleTimelineReaction.vue';


const __default__ = { name: 'ArticleTimelineReactions' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    article: null,
    paragraphOffsetMap: null,
    msToPercentage: null
  },
  setup(__props: any) {

const { article, paragraphOffsetMap, msToPercentage } = __props as {
  article: Article;
  paragraphOffsetMap: Map<string, number>;
  msToPercentage: (ms: number) => number;
}


const store = useStore();
const reactions = computed(() => store.state.commentsSidebar.recordingReactions);
const isVisible = computed(() => !!(reactions.value.length && article));

const getParagraphOffset = (paragraphId: string) => {
  return paragraphOffsetMap ? paragraphOffsetMap.get(paragraphId) || 0 : 0;
};
const calculateReactionPosition = (reaction: RecordingReaction) => {
  const time = reaction.time + getParagraphOffset(reaction.paragraphId);

  return msToPercentage ? msToPercentage(time) : 0;
};

return { __sfc: true,store, reactions, isVisible, getParagraphOffset, calculateReactionPosition, ArticleTimelineReaction }
}

})